import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  background: (theme) => ({
    backgroundColor: theme.colors.backgroundColor
  })
})

export default styles
